declare global {
  interface Console {
    defaultError: any
    errors: Array<
      Array<Error>
    >
  }
}

export const initErrorLogging = () => {
  console.defaultError = console.error.bind(console)
  console.errors = []
  console.error = function(){
    // default &  console.error()
    console.defaultError.apply(console, arguments)
    // new & array data
    console.errors.push(Array.from(arguments))
  }
}